import * as moment from 'moment-timezone';
var FooterComponent = (function () {
    function FooterComponent() {
        this.userSite = 'userSite';
    }
    FooterComponent.prototype.ngOnInit = function () {
        this.currentYear = moment().tz('Europe/Berlin').format('YYYY');
    };
    return FooterComponent;
}());
export { FooterComponent };



// WEBPACK FOOTER //
// /codebuild/output/src3658806670/src/client/web-client/src/app/theme/footer/footer.component.ts.pre-build-optimizer.js